import React from 'react';
import styles from './Advt.module.css';
import { iconsSources } from '../../helpers/icons';

const Advt = React.memo(({ advtInfo }) => {
  let format = advtInfo.number ? '+7 xxx xxx-xx-xx' : '';
  if (advtInfo.number) {
    if (!advtInfo.number.includes('-') && !advtInfo.number.includes('+7')) {
      for (let i = 0; i < advtInfo.number.length; i++) {
        format = format.replace('x', advtInfo.number[i]);
      }
    } else if (
      advtInfo.number.includes('+7') &&
      !advtInfo.number.includes('-')
    ) {
      for (let i = 2; i < advtInfo.number.length; i++) {
        format = format.replace('x', advtInfo.number[i]);
      }
    } else {
      format = advtInfo.number;
    }
  }

  return (
    <div className={styles.advtblock}>
      {advtInfo.label && (
        <div className={styles.advtTitle}>{advtInfo.label}</div>
      )}

      <div className={styles.advtNumber}>{format}</div>
      <div className={styles.advtSocials}>
        {advtInfo.socials &&
          advtInfo.socials.map((item) => (
            <div key={item} className={styles.advtIcon}>
              <img src={iconsSources[item]} alt="social" />
            </div>
          ))}
      </div>
    </div>
  );
});

export default Advt;
